(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('AccessLevelFranchiserFormController', AccessLevelFranchiserFormController)

    /** @ngInject */
    function AccessLevelFranchiserFormController($filter, $q, $stateParams, HelperService, AccessLevelService, ApiService) {
        const vm = this;
        const accessLevelId = $stateParams.accessLevelId;
        let accessLevelOriginalData;
        let permissionOriginalData;

        // ÁREA CUSTOM METHODS
        vm.savePermissions = () => {
            HelperService.startLoading('.loading-holder');

            let permissionData = vm.permissions;

            ApiService
                .saveAccessLevelPermissions(permissionData)
                .then(
                    () => {
                        angular.copy(vm.accessLevelData, accessLevelOriginalData);
                        angular.copy(vm.permissions, permissionOriginalData);

                        HelperService.stopLoading('.loading-holder');
                        HelperService.successCallback();
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.loading-holder');
                    })
        }

        vm.changeTab = tabId => {
            vm.selectedTab = tabId;
        }

        vm.setPermissionRelationshipVars = (index, apiController) => {
            if (!vm.permissions[index])
                vm.permissions[index] = {};

            vm.permissions[index].AccessLevelId = vm.accessLevelData.Id;
            vm.permissions[index].ApiControllerId = apiController.Id;
        }

        vm.onChangeRecordPermission = permission => {
            permission.IsPost = permission.IsRecord;
            permission.IsPut = permission.IsRecord;
        }

        vm.onCheckAll = () => {
            for (let index = 0; index < vm.permissions.length; index++) {
                const permission = vm.permissions[index];

                permission.IsGet = vm.getAll;
                permission.IsRecord = vm.getAll;
                permission.IsPost = vm.getAll;
                permission.IsPut = vm.getAll;
                permission.IsDelete = vm.getAll;
            }
        }

        init();

        function getAccessLevel() {
            if (!accessLevelId) {
                HelperService.stopLoading('.loading-holder');
                return;
            }

            AccessLevelService
                .get(accessLevelId)
                .then(success => {
                    vm.accessLevelData = success;

                    for (let index = 0; index < success.ApiController_AccessLevel.length; index++) {
                        const permission = success.ApiController_AccessLevel[index];

                        permission.IsRecord = permission.IsPost;
                    }

                    vm.permissions = $filter('orderBy')(success.ApiController_AccessLevel, 'ApiControllerId', false);

                    accessLevelOriginalData = angular.copy(vm.accessLevelData);
                    permissionOriginalData = angular.copy(vm.permissions);

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                })
        }

        function getControllers() {
            return ApiService
                .getControllers()
                .then(success => {
                    vm.apiControllers = $filter('orderBy')(success, 'Description', false);
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                })
        }

        function init() {
            vm.selectedTab = 1;
            vm.selectOptions = [{
                Value: true,
                Description: 'SIM'
            }, {
                Value: false,
                Description: 'NÃO'
            }];
            vm.getAll = null;

            HelperService.startLoading('.loading-holder');

            $q.all([getControllers()])
                .then(() => {
                    getAccessLevel();
                })
        }
    }
}());